//interfaces
import { getContentDeletedBannerMessage } from "@/helpers/ActivityFeed";
import { IUseContentLike } from "@/interfaces/activityFeedNotifications";
import { ActionFeedback} from "thrive-components";



const UseContentLike = ({isPopOut, timeStamp, dateStamp, parentList, content, appDetails, notificationDetails, isRemovedFromParentList, getOpenOnWebLink}: IUseContentLike) => {
    const contentIsRemoved = isRemovedFromParentList || content.isArchived;
    const screenClassName = isPopOut ? "" : "full-screen-styling";
    const archivedClassName = content.isArchived ? "archived-content" : "";
    const showFeedbackBanner : boolean = !!notificationDetails;
    const feedbackType = notificationDetails?.isSuccess ? ActionFeedback.SUCCESS : ActionFeedback.ERROR;
    const feedbackMessage = notificationDetails?.message ?? '';
    const showDeletedBanner = content.isArchived || isRemovedFromParentList;
    const deletedBannerMessage = getContentDeletedBannerMessage(false, false, content.isArchived, parentList?.title);
    const webLink = contentIsRemoved ? undefined : getOpenOnWebLink;
    const activityInfo = {
        className: screenClassName, 
        time: isPopOut ? timeStamp : undefined, 
        dateStamp: `${timeStamp} · ${dateStamp}`,
        appImageUrl: appDetails?.isMultipleAppOrganisation ? appDetails.iconUrl : "",
        appName: appDetails?.isMultipleAppOrganisation ? appDetails.name : "",
        contentTitle: parentList?.title ?? undefined,
        contentLink: parentList?.link ?? undefined
    }

    return { contentIsRemoved, screenClassName, archivedClassName, showFeedbackBanner, feedbackType, feedbackMessage, showDeletedBanner, deletedBannerMessage, webLink, activityInfo }
};

export default UseContentLike